// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login_wrapper__VBDmt"};